import { createStore } from 'vuex'
import client from './client'

export default createStore({
  modules: {
    client
  }
})
